export class FixedLayer {
    private curtainElement!: HTMLElement;
    private layerElement!: HTMLDivElement;
    private bodyElement!: HTMLElement;
    private isOpen = false;

    private popStateEventListener = () => this._close(false);

    constructor(
        headlineContent: string,
        bodyContent: string,
        private closeCallback: () => void
    ) {
        this.createLayerAndCurtainDivs(headlineContent, bodyContent);
        this.open();
    }

    private createLayerAndCurtainDivs(headlineContent: string, bodyContent: string): void {
        const contentWrapperElement = this._createElement('div', 'pdp_fixed-layer__content-wrapper');
        const contentElement = this._createElement('table', 'pdp_fixed-layer__content');
        const headlineWrapperElement = this._createElement('tr', 'pdp_fixed-layer__headline-wrapper');
        const bodyWrapperElement = this._createElement('tr', 'pdp_fixed-layer__body-wrapper');

        this.curtainElement = this._createElement('div', 'pdp_fixed-layer-curtain');
        this.layerElement = this._createElement('div', 'pdp_fixed-layer pdp_fixed-layer--hidden') as HTMLDivElement;
        const headerElement = this._createElement('div', 'pdp_fixed-layer__header');
        const closeElement = this._createElement('a', 'pdp_fixed-layer__close', 'X');
        const headlineElement = this._createElement('td', 'pdp_fixed-layer__headline', headlineContent);
        this.bodyElement = this._createElement('td', 'pdp_fixed-layer__body', bodyContent);

        headerElement.appendChild(closeElement);
        headlineWrapperElement.appendChild(headlineElement);
        bodyWrapperElement.appendChild(this.bodyElement);
        contentElement.appendChild(headlineWrapperElement);
        contentElement.appendChild(bodyWrapperElement);
        contentWrapperElement.appendChild(contentElement);
        this.layerElement.appendChild(headerElement);
        this.layerElement.appendChild(contentWrapperElement);

        this.curtainElement.addEventListener('click', () => this.close());
        /*                                                                  */
        headerElement.addEventListener('click', () => this.close());

        document.body.appendChild(this.curtainElement);
        document.body.appendChild(this.layerElement);
    }

    private open(): void {
        this._createHistoryEntryForLayer();
        this.isOpen = true;

        /*                                                                     */
        /*                                                                */
        window.getComputedStyle(this.layerElement).opacity;

        this.layerElement.classList.remove('pdp_fixed-layer--hidden');
        this.curtainElement.classList.remove('pdp_fixed-layer-curtain--hidden');

        try {
            /*                                       */
            o_global.pali.scrollTopButton.hideButton();
        } catch (_e) {}

        window.addEventListener('popstate', this.popStateEventListener);

        /*                                                                                                    */
        if (document.activeElement && document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
    }

    public setBodyContent(content: string | HTMLElement): void {
        if (typeof content === 'string') {
            this.bodyElement.innerHTML = content;
        } else {
            if (!content.classList.contains('pdp_fixed-layer__body')) {
                content.classList.add('pdp_fixed-layer__body');
            }
            this.bodyElement.parentNode?.replaceChild(content, this.bodyElement);
            this.bodyElement = content;
        }
    }

    public close(): void {
        this._close(true);
    }

    private _close(cleanUpHistory: boolean): void {
        if (this.isOpen) {
            this.isOpen = false;
            /*                             */
            const transitionEvent = o_util.event.whichTransitionEndEvent();

            const closeHandler = () => {
                this.layerElement.removeEventListener(transitionEvent, closeHandler);
                this.removeLayerAndCurtain();
            };

            if (typeof transitionEvent !== 'undefined' && transitionEvent !== '') {
                /*                                            */
                this.layerElement.addEventListener(transitionEvent, closeHandler);
            } else {
                /*                          */
                this.removeLayerAndCurtain();
            }

            this.layerElement.classList.add('pdp_fixed-layer--hidden');
            this.curtainElement.classList.add('pdp_fixed-layer-curtain--hidden');

            window.removeEventListener('popstate', this.popStateEventListener);

            if (cleanUpHistory && this.hasHistoryApi()) {
                history.go(-1);
            }

            if (this.closeCallback) {
                this.closeCallback();
            }
        }
    }

    private removeLayerAndCurtain() {
        this.layerElement.parentNode?.removeChild(this.layerElement);
        this.curtainElement.parentNode?.removeChild(this.curtainElement);
    }

    private _createHistoryEntryForLayer() {
        if (this.hasHistoryApi()) {
            history.pushState({}, document.title, location.href);
        }
    }

    private _createElement(name: string, className: string, innerHTML?: string): HTMLElement {
        const element = document.createElement(name);
        element.className = className;
        if (innerHTML) {
            element.innerHTML = innerHTML;
        }
        return element;
    }

    private hasHistoryApi(): boolean {
        if (!history || !history.pushState) {
            return false;
        }

        /*                                                                                        */
        const isIe10Mode = Function('/*                                         */')();

        return !isIe10Mode;
    }
}
